
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DotsProgress',

  props: {
    total: { type: Number, required: true },
    currentIndex: { type: Number, required: true },
  },
});
